export const generateActivationUrl = (activationToken: string, baseUrl: string) => (
	new URL(`auth/activation/?t=${activationToken}`, baseUrl).href
);
